import { useNavigate } from "react-router-dom";
import appIcon from "../../images/app_icon.jpg"
import "../../styles/PlayerCardItem.css"
import { convertToCommaString } from "../../helpers/Converter";

function PlayerOptionsItem({ size, option }) {
    const { company, units, mode, strikePrice, validUpto } = option;
    const navigate = useNavigate();
    const text = `${mode === "call" ? "Buy" : "Sell"} ${convertToCommaString(units * 1000)} shares at ₹${strikePrice} per share`
    const comment = `Valid upto round ${validUpto + 1}`;
    return (
        <div style={{ margin: "14px" }} onClick={() => {
            navigate(`/company/${company}`);
        }}>
            <div className={`player-cards-item-container-${size}`}>
                <img className={`player-cards-item-image-${size}`} src={company ? `${process.env.REACT_APP_SERVER_URL}/image/${company}.png` : appIcon} alt=""></img>
                <div className={`player-cards-item-price-details-mode-none`}>
                    {<p className="player-cards-item-company">{company.toUpperCase()}</p>}
                    {<p style={{ marginTop: "-10px" }}>{text}</p>}
                    {<p style={{ color: "black", fontSize: "0.8rem" }}>{comment}</p>}
                </div>
            </div>
        </div>
    )
}

export default PlayerOptionsItem;